<template>
    <div class="helpdesk">


    </div>
</template>





<script>
    export default {
        name: "HelpDesk"
        
    }


</script>


<style scoped>

    .helpdesk {
        padding: 0;
        margin: 0;
    }

</style>